import { User } from "../types/user";

export const mapKatswiriUser = (user: any): User => ({
  id: user._id,
  name: user.name,
  email: user.email && user.email.trim() !== "" ? user.email : undefined,
  phone: user.phone && user.phone.trim() !== "" ? user.phone : undefined,
  country: user.country || "Malawi",
  service_name: "katswiri",
  createdAt: user.created_at,
  devices: user.devices ?? [],
});

export const mapKanemaUser = (user: any): User => ({
  id: user._id,
  name: user.username,
  email: user.email && user.email.trim() !== "" ? user.email : undefined,
  phone: user.phone && user.phone.trim() !== "" ? user.phone : undefined,
  country: user.country || "Malawi",
  service_name: "kanema online",
  createdAt: user.created_at,
  devices: user.devices ?? [],
});

export const mapMingoliUser = (user: any): User => ({
  id: user.id,
  name: user.name,
  email: user.email && user.email.trim() !== "" ? user.email : undefined,
  phone: user.phoneNumber && user.phoneNumber.trim() !== "" ? user.phoneNumber : undefined,
  country: "Malawi",
  service_name: "mingoli",
  createdAt: user.createdAt,
  devices: user.devices ?? [],
});
